import React from 'react';
import { connect } from 'react-redux';
import { DropDown } from '../../../common/dropdown';
import { I18n } from 'react-redux-i18n';
import { changeWatchList, fetchMyWatchList, REDUCER_NAME } from './reducer';
import Const from './Const';

const acceptTypes = [
  Const.watchListType.COMPANY_GROUP,
  Const.watchListType.CUSTOM,
];

class DropDownWatchList extends React.Component {
  componentDidMount() {
    const { fetchMyWatchList, watchListId } = this.props;
    fetchMyWatchList(watchListId);
  }

  onChange = select => {
    const { changeWatchList } = this.props;
    changeWatchList(select);
  };

  getDataDropdown = () => {
    const { watchLists, isOverview } = this.props;
    let listKey = [0];
    const listDataByKey = {
      0: {
        watchListId: 0,
        text: I18n.t('common.all'),
        code: I18n.t('common.all'),
        typeCode: '',
      },
    };
    watchLists.forEach(item => {
      if (acceptTypes.includes(item.typeCode)) {
        listKey.push(item.watchListId);
        listDataByKey[item.watchListId] = item;
      }
    });
    if (isOverview) {
      listKey = listKey.filter(id => ![37, 34, 33, 0].includes(id));
    }

    return {
      listKey: listKey,
      listDataByKey,
    };
  };

  render() {
    const { watchListId } = this.props;
    const { listDataByKey, listKey } = this.getDataDropdown();

    return (
      <div className="list-filter w-120px mr-10">
        <div className="line-drop">
          <DropDown
            listKey={listKey}
            listDataByKey={listDataByKey}
            currentKey={watchListId}
            keyTitle={'text'}
            change={this.onChange}
            isEditable={false}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    listWatchListId: state[REDUCER_NAME].listWatchListId,
    listWatchListByWatchListId: state[REDUCER_NAME].listWatchListByWatchListId,
    watchListId: state[REDUCER_NAME].watchListId,
    watchLists: state[REDUCER_NAME].watchLists,
    locale: state.i18n.locale,
  };
};

const mapDispatchToProps = {
  changeWatchList,
  fetchMyWatchList,
};

DropDownWatchList.defaultProps = {
  watchLists: [],
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DropDownWatchList);
